import React, { useEffect, useState } from "react";
import { ClickButton } from "../../../base/buttons";
import { AbstractDialog } from "../../../base/dialog";
import { translate } from "../../../base/i18n";
import { ROLE } from "../../../base/participants";
import { connect } from "../../../base/redux";
import { participantInnerGroup } from "../../constants";
import { getGroupParticipant } from "../../function";
import AddGroupButton from "../AddGroupButton";
import GroupSearchBar from "../GroupSearchBar";
import GroupTable from "../GroupTable";
import { FocusButtonStyled } from "../styled";

function ModifyGroupStatus({
    t, list, participants, setChangeParticipantMode, handlerAlertMessage
}) {
    const [ filter, setFilter ] = useState();
    
    const [ changeMember, setChangeMember ] = useState(new Array());
    const [ data, setData ] = useState(new Map());

    useEffect(() => {        
        setChangeMember(changeMember => {
            let test = new Array();
            participants.map(member => {            
                const dupMember = changeMember.find(m => m.user_id === member.user_id);
                if (dupMember) {
                    test.push({ ...dupMember, status: member.status, nickname: member.nickname });
                } else {
                    test.push({ ...member });
                }
            });

            setChangeMember([ ...test ]);
        });
    }, [participants]);

    const submitGroup = async () => {
        let reset = new Map();
        let unset = new Map(); 
        data.forEach(async (item, user_id) => {
            let groupId = item.group_id;
            if (item.type === "unset") {
                const prevGroup = participants.find(p => p.user_id === user_id);
                groupId = prevGroup ? prevGroup.group_id : "";
            }
            
            if (groupId !== "") {
                if (item.type === "unset") {
                    const prevGroup = unset.get(groupId);
                    if (prevGroup) unset.set(groupId, [...prevGroup, {user_id, role_name: item.role_name }]);
                    else unset.set(groupId, [ {user_id, role_name: item.role_name }]);
                } else {
                    const prevGroup = reset.get(groupId);
                    if (prevGroup) reset.set(groupId, [...prevGroup, {user_id, role_name: item.role_name }]);
                    else reset.set(groupId, [{user_id, role_name: item.role_name }]);
                }
            }  
        });

        reset.forEach(async (item, key) => {
            const { complete, message } = await APP.API.assignGroup({ members: item, method: "reset" }, key);
            if (!complete) handlerAlertMessage(t(message));
        });

        unset.forEach(async (item, key) => {
            const { complete, message } = await APP.API.assignGroup({ members: item, method: "unset" }, key);
            if (!complete) handlerAlertMessage(t(message));
        });

        setChangeParticipantMode(false);
    }

    const handlerGroupChange = (item, group) => {
        let members = changeMember;
        const index = members.findIndex(m => m.user_id === item.user_id);
        
        if (index !== -1) {
            const role = group !== "" ? ROLE.PARTICIPANT : "";
            // 그룹 아이디가 바뀜. 
            if (item.group_id !== group) {
                
                let newData = data; 
                if (group === "") {
                    newData.set(item.user_id, {type: "unset", group_id: group, role_name: ROLE.PARTICIPANT });
                } else {
                    newData.set(item.user_id, {type: "reset", group_id: group, role_name: ROLE.PARTICIPANT });
                }
                setData(newData);
            }

            const prevMember = members[index];
            
            members.splice(index, 1, {...prevMember, group_id: group, role_name: role });
        }

        setChangeMember([ ...members ]);
    }

    const handlerGroupRoleChange = (item, role) => {
        let members = changeMember;
        const index = members.findIndex(m => m.user_id === item.user_id);
        if (index !== -1) {
            const prevMember = members[index];
            members.splice(index, 1, {...prevMember, role_name: role});

            let newData = data;
            newData.set(item.user_id, {type: "reset", group_id: item.group_id, role_name: role });
            setData(newData);
        }

        setChangeMember([ ...members ]);
    }

    return (
        <>
            <GroupTable tableConfig={participantInnerGroup} contentList={changeMember} filter={filter} 
                handlerGroupChange={handlerGroupChange} 
                handlerGroupRoleChange={handlerGroupRoleChange}>
                <span className="guid" style={{margin: "10px auto"}}>{ t("group.otherAuth") }</span>
                <GroupSearchBar setFilter={setFilter} />
            </GroupTable>

            <FocusButtonStyled>
                <ClickButton clsName="user_btn" text={t("common.previous")} size={20} onClick={() => setChangeParticipantMode(false)} />
                <ClickButton clsName="user_btn noback" text={ t("group.apply") } line={true} size={24} background="transparent" color="#ff4040" 
                    hBackground="#ff4040" hColor="#fff" onClick={submitGroup}/>
            </FocusButtonStyled>
        </>
    )
}

function _mapStateToProps(state) {
    const participants = getGroupParticipant(state);

    return {
        participants
    }
}

export default translate(connect(_mapStateToProps)(ModifyGroupStatus));